const _excluded = ["canonicalUrl", "children", "logger", "spectrum", "linkComponent", "imageComponent", "microcopies", "locale", "localeFromUrl", "defaultLoggedOutConfig", "fallbackLoggedOutConfig", "deploymentTargetName", "messages"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { useCallback } from 'react';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from '@cbhq/cds-web/system/ThemeProvider';
import { CanonicalUrlProvider } from './CanonicalUrlProvider.js';
import { DeploymentTargetProvider } from './DeploymentTargetProvider.js';
import { ImageComponentProvider } from './ImageComponentProvider.js';
import { LinkComponentProvider } from './LinkComponentProvider.js';
import { LocaleProvider } from './LocaleProvider.js';
import { useLogger, LoggerProvider } from './LoggerProvider.js';
import { MicrocopyProvider } from './MicrocopyProvider.js';
import { SectionSpacingProvider } from './SectionSpacingProvider.js';
import { jsx } from 'react/jsx-runtime';
const CDSThemeProviderWithChildren = ThemeProvider;
function ComponentsProvider(_ref) {
  let canonicalUrl = _ref.canonicalUrl,
    children = _ref.children,
    logger = _ref.logger,
    spectrum = _ref.spectrum,
    linkComponent = _ref.linkComponent,
    imageComponent = _ref.imageComponent,
    microcopies = _ref.microcopies,
    locale = _ref.locale,
    localeFromUrl = _ref.localeFromUrl,
    defaultLoggedOutConfig = _ref.defaultLoggedOutConfig,
    fallbackLoggedOutConfig = _ref.fallbackLoggedOutConfig,
    deploymentTargetName = _ref.deploymentTargetName,
    messages = _ref.messages,
    sectionSpacingProps = _objectWithoutProperties(_ref, _excluded);
  const _useLogger = useLogger(),
    notifyError = _useLogger.notifyError;

  /*
   * This is very noisy so only sending 5% of the events.
   */
  const onError = useCallback(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  err => {
    if (Math.random() * 100 < 5 && err.code !== 'MISSING_TRANSLATION') {
      notifyError(err?.code);
    }
  }, [notifyError]);
  return /*#__PURE__*/jsx(IntlProvider, {
    messages: messages || {},
    locale: locale,
    onError: onError,
    children: /*#__PURE__*/jsx(DeploymentTargetProvider, {
      deploymentTargetName: deploymentTargetName || 'development',
      children: /*#__PURE__*/jsx(LocaleProvider, {
        locale: locale,
        localeFromUrl: localeFromUrl,
        defaultLoggedOutConfig: defaultLoggedOutConfig,
        fallbackLoggedOutConfig: fallbackLoggedOutConfig,
        children: /*#__PURE__*/jsx(LoggerProvider, {
          logger: logger,
          children: /*#__PURE__*/jsx(MicrocopyProvider, {
            microcopies: microcopies,
            children: /*#__PURE__*/jsx(CanonicalUrlProvider, {
              canonicalUrl: canonicalUrl,
              children: /*#__PURE__*/jsx(SectionSpacingProvider, _objectSpread(_objectSpread({}, sectionSpacingProps), {}, {
                children: /*#__PURE__*/jsx(LinkComponentProvider, {
                  linkComponent: linkComponent,
                  children: /*#__PURE__*/jsx(ImageComponentProvider, {
                    imageComponent: imageComponent,
                    children: /*#__PURE__*/jsx(CDSThemeProviderWithChildren, {
                      spectrum: spectrum,
                      children: children
                    })
                  })
                })
              }))
            })
          })
        })
      })
    })
  });
}
export { ComponentsProvider };
//# sourceMappingURL=ComponentsProvider.js.map
